import React, { useEffect, useState } from 'react'
import {allKYCDataType} from '../../property/PropertyDataTypes'
import styles from '../KYCDetailsStyles/KYCDetailsStyle.module.scss'
import PaginationComponent from '../../PaginationComponent/Pagination'

const PreviousKYCTable = ({allKYC}: {allKYC: allKYCDataType[]}) => {
  const [itemOffset, setItemOffset] = useState<number>(0)
  const [dataLength, setDataLength] = useState<number>(allKYC.length)
  const [currentKYC, setCurrrentKYC] = useState<allKYCDataType[]>()
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10
  const pageCount = Math.ceil(dataLength / itemsPerPage)
  // function to set the color for kyc status in all kyc table
  const setBadgeColor = (statusCode: number) => {
    switch (statusCode) {
      case 0:
        // for pending
        return 'badge-light-warning'
      case 1:
        // for Active
        return 'badge-light-success'
      case 2:
        // for processing
        return `${styles.status_processing}`
      case 3:
        // for rejected
        return 'badge-light-danger'
      case 4:
        // for resubmitted
        return `${styles.status_resubmitted}`
      case 5:
        // for terminated
        return 'badge-light-dark'
      default:
        return 'badge-light-warning'
    }
  }
  useEffect(()=>{
    setCurrrentKYC(allKYC.slice(itemOffset, itemOffset + itemsPerPage))
  },[itemOffset])
  return (
    <>
    <div id='table div'>
      {/* Begin: Table */}
      <div className='card mb-5 mb-xl-8'>
        <div className='card-body py-4'>
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bold text-muted'>
                  <th className='max-w-150px'>Account KYC Name</th>
                  <th className='max-w-150px'>Account KYC Type</th>
                  <th className='max-w-150px'>Business Name</th>
                  <th className='max-w-150px'>KYC Status</th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                {currentKYC?.map((kyc, index: number) => {
                  return (
                    <tr key={index}>
                      <td className='max-w-150px'>
                        <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                          {kyc.account_kyc_name}
                        </span>
                      </td>
                      <td className='max-w-150px'>
                        <span className='text-muted fw-semibold text-muted d-block fs-7'>
                          {kyc.account_kyc_type}
                        </span>
                      </td>
                      <td className='max-w-150px'>
                        <span className='text-muted fw-semibold text-muted d-block fs-7'>
                          {kyc.business_name ? kyc.business_name : '-'}
                        </span>
                      </td>
                      <td className='max-w-150px'>
                        <span className={`badge ${setBadgeColor(kyc.account_kyc_status)}`}>
                          {kyc.account_kyc_status_msg}
                        </span>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
              {/* end::Table body */}
            </table>
            {/* end::Table */}
          </div>
        </div>
      </div>
      {/* End: Table */}
    </div>
    {
      allKYC.length>0 && pageCount>1 && (
        <PaginationComponent
          itemsPerPage={itemsPerPage}
          dataLength={dataLength}
          setItemOffset={setItemOffset}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageCount={pageCount}
        />
      )
    }
    </>
  )
}

export default PreviousKYCTable
